import { getCurrentTitle, getMultiStepProgress } from "@/lib/goals";
import { defaultFormatters } from "@/lib/utils";
import { NewMultiStepGoalDoc } from "@ailenax-overlay/shared";
import { FC, useMemo } from "react";
import CountUp from "react-countup";
import "../SimpleDonoGoalWidget/SimpleDonoGoalWidget.scss";

interface MultiStepGoalWidgetProps {
    goal: NewMultiStepGoalDoc;
}

export const MultiStepGoalWidget: FC<MultiStepGoalWidgetProps> = ({ goal }) => {
    const fullTitle = useMemo(() => getCurrentTitle(goal), [goal]);
    const { realProgress, currentThreshold, prevThreshold, fraction } = useMemo(
        () => getMultiStepProgress(goal),
        [goal]
    );

    const formatter = defaultFormatters[goal.kind];

    return (
        <div className="goal-container">
            <div className="simple-dono-goal">
                <div className="progress-bar" style={{ width: `${100 * fraction}%` }}></div>
                <div className="text">
                    <span className="title">{fullTitle}</span>{" "}
                    <span className="progress">
                        <CountUp
                            decimal=","
                            decimals={2}
                            end={realProgress}
                            duration={0.4}
                            formattingFn={formatter}
                        />
                    </span>{" "}
                    von <span className="total">{formatter(currentThreshold - prevThreshold)}</span>
                </div>
            </div>
        </div>
    );
};
